/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourSaveInput = {
    id: string;
    title?: string | null;
    description?: string | null;
    videoURL?: string | null;
    listingLink?: string | null;
    frameURLs?: Array<string> | null;
};
export type TourEditDetailsMutationVariables = {
    input: TourSaveInput;
};
export type TourEditDetailsMutationResponse = {
    readonly tourSave: {
        readonly tour: {
            readonly id: string;
            readonly title: string;
            readonly description: string;
            readonly videoURL: string;
        };
    };
};
export type TourEditDetailsMutation = {
    readonly response: TourEditDetailsMutationResponse;
    readonly variables: TourEditDetailsMutationVariables;
};



/*
mutation TourEditDetailsMutation(
  $input: TourSaveInput!
) {
  tourSave(input: $input) {
    tour {
      id
      title
      description
      videoURL
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TourSavePayload",
    "kind": "LinkedField",
    "name": "tourSave",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tour",
        "kind": "LinkedField",
        "name": "tour",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoURL",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourEditDetailsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourEditDetailsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "389032a2d726cf74d229d465b8dcf5d5",
    "id": null,
    "metadata": {},
    "name": "TourEditDetailsMutation",
    "operationKind": "mutation",
    "text": "mutation TourEditDetailsMutation(\n  $input: TourSaveInput!\n) {\n  tourSave(input: $input) {\n    tour {\n      id\n      title\n      description\n      videoURL\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '726b7ce2a492f41615a87a435f2da0ac';
export default node;
